import { Trans } from '@lingui/macro'
import React, { useEffect } from 'react'

interface IntercomProviderProps {
    children: React.ReactNode
    appId: string
}

export const IntercomProvider: React.FC<IntercomProviderProps> = ({ children, appId }) => {
    useEffect(() => {
        if (!appId) {
            return
        }

        // Check if Intercom script is already loaded
        if ((window as any).Intercom) {
            return
        }

        // Load Intercom script using the traditional approach
        const loadIntercomScript = () => {
            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.async = true
            script.src = `https://widget.intercom.io/widget/${appId}`

            script.onerror = () => {
                console.error(<Trans>Failed to load Intercom script</Trans>)
            }

            // Initialize Intercom queue using the traditional approach
            ;(window as any).Intercom = function () {
                ;(window as any).Intercom.c(arguments)
            }
            ;(window as any).Intercom.q = []
            ;(window as any).Intercom.c = function (args: any[]) {
                ;(window as any).Intercom.q.push(args)
            }

            document.head.appendChild(script)
        }

        if (document.readyState === 'complete') {
            loadIntercomScript()
        } else {
            window.addEventListener('load', loadIntercomScript)
        }

        return () => {
            window.removeEventListener('load', loadIntercomScript)
        }
    }, [appId])

    return <>{children}</>
}
